module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/ja-card-drag.0ddec2778984b56de963.gif";